import { Directive, inject, input, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/*
 * Directive extends standard `(click)` event. To have more accessible interaction
 * we should use `(ariaEvent)` output rather than `(click)` event. This directive
 * covers interaction not only by click but space and enter keyboard events as well.
 * */
@Directive({
  selector: '[ariaEvent]',
  host: {
    '(click)': 'onInteraction($event)',
    '(keydown.space)': 'onInteraction($event)',
    '(keydown.enter)': 'onInteraction($event)'
  }
})
export class AriaEventDirective {
  public ariaEvent = output<Event>();

  public onInteraction(event: Event): void {
    event?.preventDefault();
    this.ariaEvent.emit(event);
  }
}

/*
 * Directive works alongside with routerLink and do router navigate
 * on keyboard space and enter events. This allows user to navigate by
 * `tabIndex`, focus on an element and hit space/enter to trigger navigate event.
 * */
@Directive({
  selector: '[routerLink][ariaRouterEvent]',
  host: {
    '(keydown.space)': 'onInteraction()',
    '(keydown.enter)': 'onInteraction()'
  }
})
export class AriaRouterEventDirective {
  private _router = inject(Router, { optional: true });
  private _route = inject(ActivatedRoute, { optional: true });

  public routerLink = input<string>();

  public onInteraction(): void {
    if (this.routerLink && this._router) {
      void this._router.navigate([this.routerLink], {
        relativeTo: this._route
      });
    }
  }
}
